import * as React from 'react';
import { Button, IconChevronRight16, IconChevronLeft16 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Pagination = _ref => {
  let {
    page,
    lastPage,
    onChange
  } = _ref;
  if (lastPage < 2) {
    return null;
  }
  const isPrevButtonDisabled = page === 1;
  const isNextButtonDisabled = page === lastPage;
  const onNextPageClick = () => {
    onChange(page + 1);
  };
  const onPrevPageClick = () => {
    onChange(page - 1);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: style['button_group'],
    children: [/*#__PURE__*/_jsx(Button, {
      theme: "fill_secondary",
      disabled: isPrevButtonDisabled,
      onClick: onPrevPageClick,
      beforeIcon: /*#__PURE__*/_jsx(IconChevronLeft16, {
        color: isPrevButtonDisabled ? 'gray20_100' : 'icon-main-default'
      })
    }), /*#__PURE__*/_jsx(Button, {
      theme: "fill_secondary",
      disabled: isNextButtonDisabled,
      onClick: onNextPageClick,
      beforeIcon: /*#__PURE__*/_jsx(IconChevronRight16, {
        color: isNextButtonDisabled ? 'gray20_100' : 'icon-main-default'
      })
    })]
  });
};